import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, ConfigService, SummaryItem, SummaryTopComponent, TabComponent } from '../../../../tms-shared';
import { UserDetails } from '../../models';
import { UserService } from '../../services';
import { UserDetailsComponent } from '../user-details/user-details.component';
import { UserRolesComponent } from '../user-roles/user-roles.component';
import { UserCustomersComponent } from '../user-customers/user-customers.component';
import { UserChartsComponent } from '../user-charts/user-charts.component';
import { UserPrintersComponent } from '../user-printers/user-printers.component';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
  imports: [
    SummaryTopComponent,
    TabComponent,
    UserDetailsComponent,
    UserRolesComponent,
    UserCustomersComponent,
    UserChartsComponent,
    UserPrintersComponent,
    AsyncPipe,
  ],
})
export class UserComponent extends BaseComponent implements OnInit {
  private readonly userService = inject(UserService);
  private readonly route = inject(ActivatedRoute);
  protected readonly configService = inject(ConfigService);

  protected readonly detailsHeader = $localize`Details`;
  protected readonly rolesHeader = $localize`Roles`;
  protected readonly customersHeader = $localize`Customers`;
  protected readonly chartsHeader = $localize`Charts`;
  protected readonly printersHeader = $localize`Printers`;

  protected model$: Observable<UserDetails>;
  private id: string;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  protected get showAllTabs(): boolean {
    return this.configService.model.applicationName === 'TMSWeb';
  }

  summaryTopItems(model: UserDetails): SummaryItem[] {
    return [
      { label: $localize`Name`, value: `${model.firstName} ${model.lastName}` },
      { label: $localize`Username`, value: model.username },
    ];
  }

  getModel(): void {
    if (this.id) {
      this.model$ = this.userService.edit(this.id).pipe(takeUntil(this.destroy$));
    }
  }
}
